import request from "@/utils/request";

export const url = {
  GetAccountAttributes: "/api/AccountMaintenance/GetAccountAttributes",
};
function sendRequest(apiUrl, params, type) {
  return request({
    url: apiUrl,
    method: type,
    data: params,
  });
}

export default class messageApi {
  static GetAccountAttributes(params, type = "post") {
    return sendRequest(url.GetAccountAttributes, params, type);
  }
}
